import { TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutRecentCallins } from "./autogen/AutogenLayoutRecentCallins";

export class RecentCallins extends AutogenLayoutRecentCallins {
    private _newestFirst: boolean = true;
    private _includePositionCallins: boolean = false;
    public callinRowCallback = (row: ModelRow) => {}

    /** This is an event handler for the onRowDisplay event of TableCallin.  */
    /** Also, Add Click Listener to the ModelRow/GridRow */
    callinOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        const modelRow: ModelRow = tableRow.data;
        console.debug("Clicked Model Row: " + modelRow)
        tableRow.addClickListener(clickEvent => {
            const clickModelRow = clickEvent.target.data;
            console.debug(clickModelRow.get("id"));
            this.callinRowCallback(clickModelRow);
        });
    }

    public doSearch(movementId: string) {
        if (movementId) {
            this.mainDataSource.orderBy = [{ field: "call_date_time", sort: "desc" }];
            this.mainDataSource.search({ "newest_first": this._newestFirst, "movement_id": movementId, "include_positions": this._includePositionCallins });
        }
    }

    set newestFirst(value: boolean) {
        this._newestFirst = value;
    }

    set includePositions(value: boolean) {
        this._includePositionCallins = value;
    }
}
